module.exports = __webpack_public_path__ + "img/capital.96fc7140.png";